import { render, staticRenderFns } from "./courseContent.vue?vue&type=template&id=fcae4f44&scoped=true&"
import script from "./courseContent.vue?vue&type=script&lang=js&"
export * from "./courseContent.vue?vue&type=script&lang=js&"
import style0 from "./courseContent.vue?vue&type=style&index=0&id=fcae4f44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcae4f44",
  null
  
)

export default component.exports